import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "panel", "summary", "chevron", "checkbox"];
  static values = { placeholder: String };

  connect() {
    this.isOpen = false;
    this._onClickOutside = this._onClickOutside.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
    document.addEventListener("click", this._onClickOutside);
    document.addEventListener("keydown", this._onKeydown);
    this.syncSummary();
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside);
    document.removeEventListener("keydown", this._onKeydown);
  }

  toggle() {
    if (this.triggerTarget.disabled) return;
    this.isOpen = !this.isOpen;
    this._applyOpenState();
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this._applyOpenState();
  }

  syncSummary() {
    const selected = this.checkboxTargets
      .filter((cb) => cb.checked)
      .map((cb) => cb.dataset.itemLabel);
    this.summaryTarget.textContent =
      selected.length > 0 ? selected.join(", ") : this._placeholder;
  }

  // -- private ---------------------------------------------------------------

  _applyOpenState() {
    this.panelTarget.classList.toggle("hidden", !this.isOpen);
    this.triggerTarget.setAttribute("aria-expanded", String(this.isOpen));
    this.chevronTarget.classList.toggle("rotate-180", this.isOpen);
  }

  _onClickOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  _onKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this.close();
      this.triggerTarget.focus();
    }
  }

  get _placeholder() {
    return this.hasPlaceholderValue ? this.placeholderValue : "Select…";
  }
}
